import { visit, SKIP } from 'unist-util-visit';
const remarkUnderlineHtmlVisitor = ()=>(tree)=>{
        visit(tree, (node, index, parent)=>{
            // if node is not u tag we skip
            if (!parent || node.type !== 'html' || node.value?.trim() !== '<u>') {
                return;
            }
            const siblings = parent.children;
            const openIdx = index;
            // look ahead for the matching closing tag in the same sibling list
            let closeIdx = openIdx + 1;
            while(closeIdx < siblings.length && !(siblings[closeIdx].type === 'html' && siblings[closeIdx].value?.trim() === '</u>')){
                closeIdx++;
            }
            if (closeIdx === siblings.length) return; //  No closing </u> → ignore
            //  Everything in-between becomes the children of the new node
            const underlinedChildren = siblings.slice(openIdx + 1, closeIdx);
            const underlineNode = {
                type: 'underline',
                data: {
                    hName: 'u'
                },
                children: underlinedChildren
            };
            //  Replace <u> … </u> with a single underline node
            siblings.splice(openIdx, closeIdx - openIdx + 1, underlineNode);
            // Tell the visitor to skip further traversal into the new node
            return [
                SKIP,
                openIdx
            ];
        });
    };
export default remarkUnderlineHtmlVisitor;
